import { render, staticRenderFns } from "./txtGroupControl.vue?vue&type=template&id=54adebc1&scoped=true&"
import script from "./txtGroupControl.vue?vue&type=script&lang=js&"
export * from "./txtGroupControl.vue?vue&type=script&lang=js&"
import style0 from "./txtGroupControl.vue?vue&type=style&index=0&id=54adebc1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54adebc1",
  null
  
)

export default component.exports